import {
  FormModal,
  FormField,
  FormInput,
  FormSelect,
  FormTextarea,
} from '@/components/ui/form-modal';

export interface SupplierFormData {
  name: string;
  contactName: string;
  email: string;
  phone: string;
  country: string;
  categories: string[];
  paymentTerms: string;
  notes: string;
}

interface SupplierFormModalProps {
  readonly isOpen: boolean;
  readonly isEditing: boolean;
  readonly formData: SupplierFormData;
  readonly onFormChange: (data: SupplierFormData) => void;
  readonly onClose: () => void;
  readonly onSave: () => void;
}

export function SupplierFormModal({
  isOpen,
  isEditing,
  formData,
  onFormChange,
  onClose,
  onSave,
}: SupplierFormModalProps) {
  return (
    <FormModal
      title={isEditing ? 'Edit Supplier' : 'Add Supplier'}
      description={
        isEditing
          ? 'Update supplier details'
          : 'Add a new supplier to your network'
      }
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      saveLabel={isEditing ? 'Update' : 'Create'}
      size="xl"
    >
      <div className="grid gap-4 md:grid-cols-2">
        <FormField label="Company Name" required>
          <FormInput
            value={formData.name}
            onChange={(e) => onFormChange({
              ...formData,
              name: e.target.value,
            })}
            placeholder="e.g., Ocean Fresh Seafood"
          />
        </FormField>
        <FormField label="Contact Name">
          <FormInput
            value={formData.contactName}
            onChange={(e) => onFormChange({
              ...formData,
              contactName: e.target.value,
            })}
            placeholder="e.g., John Smith"
          />
        </FormField>
        <FormField label="Email" required>
          <FormInput
            type="email"
            value={formData.email}
            onChange={(e) => onFormChange({
              ...formData,
              email: e.target.value,
            })}
            placeholder="contact@supplier.com"
          />
        </FormField>
        <FormField label="Phone">
          <FormInput
            type="tel"
            value={formData.phone}
            onChange={(e) => onFormChange({
              ...formData,
              phone: e.target.value,
            })}
            placeholder="+1 (555) 123-4567"
          />
        </FormField>
        <FormField label="Country" required>
          <FormSelect
            value={formData.country}
            onChange={(e) => onFormChange({
              ...formData,
              country: e.target.value,
            })}
            placeholder="Select country..."
            options={[
              {
                value: 'USA',
                label: 'United States',
              },
              {
                value: 'Spain',
                label: 'Spain',
              },
              {
                value: 'Italy',
                label: 'Italy',
              },
              {
                value: 'France',
                label: 'France',
              },
              {
                value: 'Mexico',
                label: 'Mexico',
              },
              {
                value: 'Canada',
                label: 'Canada',
              },
            ]}
          />
        </FormField>
        <FormField label="Payment Terms">
          <FormSelect
            value={formData.paymentTerms}
            onChange={(e) => onFormChange({
              ...formData,
              paymentTerms: e.target.value,
            })}
            placeholder="Select terms..."
            options={[
              {
                value: 'Net 15',
                label: 'Net 15',
              },
              {
                value: 'Net 30',
                label: 'Net 30',
              },
              {
                value: 'Net 45',
                label: 'Net 45',
              },
              {
                value: 'Net 60',
                label: 'Net 60',
              },
              {
                value: 'COD',
                label: 'Cash on Delivery',
              },
            ]}
          />
        </FormField>
      </div>
      <FormField label="Notes">
        <FormTextarea
          value={formData.notes}
          onChange={(e) => onFormChange({
            ...formData,
            notes: e.target.value,
          })}
          placeholder="Additional notes about this supplier..."
          rows={2}
        />
      </FormField>
    </FormModal>
  );
}
